import IconStyle from './IconStyle';

export default IconStyle;
